/*
  TDate用于处理不区分时区的时间，使用举列：

  1. 获取当前时间
    new TDate() // 精确到毫秒, 如：2019-10-26 22:15:28.329
    new TDate('year') // 精确到年，如：2019-1-1
    new TDate('month') // 精确到月, 如：2019-10-1
    new TDate('date') // 精确到日, 如：2019-10-26
    new TDate('hour') // 精确到小时, 如：2019-10-26 22:00
    new TDate('minute') // 精确到分钟, 如：2019-10-26 22:15
    new TDate('second') // 精确到秒, 如：2019-10-26 22:15:28

  2. 根据年月日时分秒获取指定时间
    new TDate(2019, 9) // 2019-10-1
    new TDate(2019, 9, 26) // 2019-10-26
    new TDate(2019, 9, 26, 22) // 2019-10-26 22:00
    new TDate(2019, 9, 26, 22, 15) // 2019-10-26 22:15
    new TDate(2019, 9, 26, 22, 15, 28) // 2019-10-26 22:15:28
    new TDate(2019, 9, 26, 22, 15, 28, 329) // 2019-10-26 22:15:28.329

  3. 根据时间参数获取指定时间
    new TDate(1572064228393) // 2019-10-26 4:30:28.393

  4. 时间加减法(正值加，负值减)
    new TDate(2019, 9, 26, 22, 15).add(1, 20) // 2019-10-26 22:15 加上1天20小时，结果：2019-10-28 18:15
    new TDate(2019, 9, 26, 22, 15).add(1, 20, 1, 20, 300) // 2019-10-26 22:15 加上1天20小时1分钟20秒300毫秒，结果：2019-10-28 18:16:20.300

  5. 获取时间的日期
     new TDate(2019, 9, 26, 22, 15).getDate() // 2019-10-26 22:15 的日期，结果：2019-10-26
  
  6. 计算时间间隔
    new TDate(2019, 9, 26, 22, 15).add(1, 20).subtract(new TDate(2019, 9, 26, 22, 15))
    // TTimeSpan {
    //   totalMilliSeconds: 158400000,
    //   totalSeconds: 158400,
    //   totalMinutes: 2640,
    //   totalHours: 44,
    //   totalDays: 1.8333333333333333,
    //   days: 1,
    //   hours: 20,
    //   minutes: 0,
    //   seconds: 0,
    //   milliseconds: 0 }
*/

export function TDate() {
  const setDate = funSetDate.bind(this)
  switch (arguments.length) {
    case 0:
      const now = new Date
      return setDate(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds())
    case 1:
      if (typeof arguments[0] === 'string') {
        const now = new Date
        switch (arguments[0].toLowerCase()) {
          case 'second':
            return setDate(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds())
          case 'minute':
            return setDate(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes())
          case 'hour':
            return setDate(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours())
          case 'date':
            return setDate(now.getFullYear(), now.getMonth(), now.getDate())
          case 'month':
            return setDate(now.getFullYear(), now.getMonth())
          case 'year':
            return setDate(now.getFullYear())
          default:
            throw `'${arguments[0]}' is a unknowed parameter`
        }
      } else if (typeof arguments[0] === 'number') {
        const now = new Date(arguments[0])
        return setDate(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds())
      } else {
        throw `${arguments[0]} is not a string or number`
      }
    default:
      return setDate(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6])
  }
}

function funSetDate(year, month = 0, date = 1, hour = 0, minute = 0, second = 0, millisecond = 0) {
  this.year = year
  this.month = month
  this.date = date
  this.hour = hour
  this.minute = minute
  this.second = second
  this.millisecond = millisecond
  this.value = Date.UTC(year, month, date, hour, minute, second, millisecond)
  this.day = new Date(this.value).getDay()
}

TDate.prototype.valueOf = function () {
  return this.value
}

TDate.prototype.getDate = function () {
  return new TDate(this.year, this.month, this.date)
}

const week = { 0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六' }

TDate.prototype.toString = function (format = 'yyyy-MM-dd HH:mm:ss.ttt') {
  return format.replace(/(yyyy|MM|dd|HH|mm|ss|ttt|ww|yy|M|d|H|m|s|t|w)/g, o => {
    switch (o) {
      case 'yyyy': return this.year.toString().padStart(4, '0')
      case 'MM': return (this.month + 1).toString().padStart(2, '0')
      case 'dd': return this.date.toString().padStart(2, '0')
      case 'HH': return this.hour.toString().padStart(2, '0')
      case 'mm': return this.minute.toString().padStart(2, '0')
      case 'ss': return this.second.toString().padStart(2, '0')
      case 'ttt': return this.millisecond.toString().padStart(3, '0')
      case 'ww': return `星期${week[this.day]}`
      case 'yy': return this.year.toString().padStart(4, '0').substring(this.year.toString().padStart(4, '0').length - 2)
      case 'M': return (this.month + 1).toString()
      case 'd': return this.date.toString()
      case 'H': return this.hour.toString()
      case 'm': return this.minute.toString()
      case 's': return this.second.toString()
      case 't': return this.millisecond.toString()
      case 'w': return `${week[this.day]}`
      default:
        console.error(`error format: ${o}`)
        return o
    }
  })
}

TDate.prototype.add = function (days, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
  return new TDate(this.value + ((((days * 24) + hours) * 60 + minutes) * 60 + seconds) * 1000 + milliseconds)
}

TDate.prototype.subtract = function (tdate) {
  return new TTimeSpan(this.value - tdate.value)
}

function TTimeSpan(milliseconds) {
  this.totalMilliSeconds = milliseconds
  this.totalSeconds = milliseconds / 1000
  this.totalMinutes = this.totalSeconds / 60
  this.totalHours = this.totalMinutes / 60
  this.totalDays = this.totalHours / 24
  this.days = Math.floor(this.totalDays)
  this.hours = Math.floor((milliseconds - this.days * 24 * 60 * 60 * 1000) / 1000 / 60 / 60)
  this.minutes = Math.floor((milliseconds - (this.days * 24 + this.hours) * 60 * 60 * 1000) / 1000 / 60)
  this.seconds = Math.floor((milliseconds - ((this.days * 24 + this.hours) * 60 + this.minutes) * 60 * 1000) / 1000)
  this.milliseconds = Math.floor(milliseconds - (((this.days * 24 + this.hours) * 60 + this.minutes) * 60 + this.seconds) * 1000)
}

/*
console.log(new TDate().subtract(new TDate(2019, 9)))
// TTimeSpan {
//   totalMilliSeconds: 2203489871,
//   totalSeconds: 2203489.871,
//   totalMinutes: 36724.83118333333,
//   totalHours: 612.0805197222221,
//   totalDays: 25.503354988425922,
//   days: 25,
//   hours: 12,
//   minutes: 4,
//   seconds: 49,
//   milliseconds: 871 }

console.log(new TDate().add(1, 1, 1).subtract(new TDate(2019, 9)))
// TTimeSpan {
//   totalMilliSeconds: 2293549885,
//   totalSeconds: 2293549.885,
//   totalMinutes: 38225.83141666666,
//   totalHours: 637.0971902777777,
//   totalDays: 26.54571626157407,
//   days: 26,
//   hours: 13,
//   minutes: 5,
//   seconds: 49,
//   milliseconds: 885 }

const t1 = new TDate()
console.log('t1 =', t1)
// t1 = TDate {
//   year: 2019,
//   month: 9,
//   date: 26,
//   hour: 12,
//   minute: 4,
//   second: 49,
//   millisecond: 908,
//   value: 1572091489908,
//   day: 6 }

const t2 = new TDate()
console.log('t2 =', t2)
// t2 = TDate {
//   year: 2019,
//   month: 9,
//   date: 26,
//   hour: 12,
//   minute: 4,
//   second: 49,
//   millisecond: 912,
//   value: 1572091489912,
//   day: 6 }

console.log('t1 > t2 =', t1 > t2) // false
console.log('t1 = t2 =', t1 == t2) // false
console.log('t1 >= t2 =', t1 >= t2) // false
console.log('t1 <= t2 =', t1 <= t2) // true
console.log('t1 < t2 =', t1 < t2) // true
console.log('t1 - t2 =', t1 - t2) // -4

const t3 = new TDate()
const t4 = new TDate(t3.value)
console.log('t3 == t4 =', t3 == t4) // false
console.log('t3 >= t4 =', t3 >= t4) // true
console.log('t3 <= t4 =', t3 <= t4) // true
console.log('t3.value == t4.value =', t3.value == t4.value) // true
console.log('t3 - t4 =', t3 - t4) // 0

const tt1 = new Date()
const tt2 = new Date(tt1.valueOf())
console.log('tt1 = tt2 ==', tt1 === tt2) // false

*/